var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "rbvQuestionnaireQuestionListTypeOptions",
      attrs: { id: _vm.id },
    },
    _vm._l(_vm.template.options, function (option) {
      return _c("checkbox-button", {
        key: option.value,
        style: _vm.hasChanged
          ? "background: rgba(0, 169, 157, 0.1); border: 1px solid rgba(0, 169, 157, 1);"
          : "",
        attrs: {
          "check-box-label": _vm.createOptionLabel(
            option.label,
            option.value,
            _vm.isUserDefined
          ),
          "check-box-value": option.value,
          value: _vm.value,
          readonly: _vm.readonly,
          "is-user-defined": _vm.isUserDefined,
        },
        on: { input: _vm.onChange },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }